const convertToNull = (object: Record<string, any>): any => {
  return Object.keys(object)
    .map((key) => ({ key, value: object[key] }))
    .reduce((acc, curr) => ({ ...acc, [curr.key]: curr.value ?? null }), {}) // logic 'OR' cause 0 value is also converted to null
}

export default convertToNull
